import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SkeletonComponent } from './skeleton/skeleton.component';
import { ButtonComponent } from './button/button.component';
import { AvatarComponent } from './avatar/avatar.component';
import { SvgComponent } from './svg/svg.component';
import { RectangleComponent } from './rectangle/rectangle.component';
import { SkeletonBase } from '../Models/SkeletonBase';
import { SkeletonChartBase } from '../Models/SkeletonChartBase';
import { SkeletonSizeBase } from '../Models/SkeletonSizesBase';

@NgModule({
  declarations: [
    SkeletonSizeBase,
    SkeletonBase,
    SkeletonChartBase,
    SkeletonComponent,
    ButtonComponent,
    AvatarComponent,
    SvgComponent,
    RectangleComponent
  ],
  imports: [CommonModule],
  exports: [SkeletonComponent, ButtonComponent, AvatarComponent, SvgComponent, RectangleComponent]
})
export class SkeletonCommonModule {}
